import { render, staticRenderFns } from "./HeartBrainReport.vue?vue&type=template&id=6b6e0984&scoped=true&"
import script from "./HeartBrainReport.vue?vue&type=script&lang=js&"
export * from "./HeartBrainReport.vue?vue&type=script&lang=js&"
import style0 from "./HeartBrainReport.vue?vue&type=style&index=0&id=6b6e0984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6e0984",
  null
  
)

export default component.exports